document.addEventListener('DOMContentLoaded', function () {
  document.body.classList.add('ready')

  function observeOnScrollElements() {
    function handleIntersection(entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('scrolled-into')
          observer.unobserve(entry.target)
        }
      })
    }

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1,
    }

    const observer = new IntersectionObserver(handleIntersection, options)
    const elements = document.querySelectorAll('.on-scroll')

    elements.forEach((el) => observer.observe(el))
  }

  observeOnScrollElements()
})
